import { configureStore } from "@reduxjs/toolkit";

import appReducer from "../slices/app-slice";
import devicesPageReducer from "../slices/devices-slice";
import routinesPageReducer from "../slices/routines-slice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    devicesPage: devicesPageReducer,
    routinesPage: routinesPageReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
